export default __webpack_public_path__ + "static/media/Credit Rating December 29, 2025.c38f7785.pdf";